/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
import{compactIndices as o}from"../../../../../../geometry/support/Indices.js";function n(n){const t=new Map;for(const[r,s]of n)t.set(r,{...s,indices:o(s.indices)});return t}function t(o){const n=[];for(const[t,r]of o)n.push([t,r]);return n}export{t as attributesMapToInputAttributes,n as inputAttributesToAttributesMap};
